import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { Lock, Sparkles, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Minimum 6 caractères"); return; }
    if (password !== confirm) { toast.error("Les mots de passe ne correspondent pas"); return; }
    setLoading(true);
    try {
      await api.post("/auth/email/reset-password", { token, new_password: password });
      setDone(true);
      toast.success("Mot de passe mis à jour");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Sparkles className="w-5 h-5 text-gold" />
          <span className="font-heading text-2xl">Xook<span className="gold-text font-bold">Pub</span></span>
        </Link>
        <div className="gold-border-gradient p-8">
          {done ? (
            <div className="text-center">
              <CheckCircle2 className="w-14 h-14 text-gold mx-auto" />
              <h1 className="mt-4 font-heading text-2xl">Mot de passe mis à jour</h1>
              <p className="text-white/60 mt-2 text-sm">Redirection vers la connexion...</p>
            </div>
          ) : !token ? (
            <div className="text-center text-white/60">Lien invalide.</div>
          ) : (
            <>
              <h1 className="font-heading text-3xl tracking-tight">Nouveau mot de passe</h1>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <span className="label-mono">Nouveau mot de passe</span>
                  <div className="mt-1 flex items-center gap-2 bg-obsidian-light border border-white/10 rounded-lg px-3 focus-within:border-gold/50">
                    <Lock className="w-4 h-4 text-white/40" />
                    <input data-testid="reset-new-password" type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} className="bg-transparent flex-1 py-3 outline-none text-sm" />
                  </div>
                </div>
                <div>
                  <span className="label-mono">Confirmation</span>
                  <div className="mt-1 flex items-center gap-2 bg-obsidian-light border border-white/10 rounded-lg px-3 focus-within:border-gold/50">
                    <Lock className="w-4 h-4 text-white/40" />
                    <input data-testid="reset-confirm-password" type="password" required minLength={6} value={confirm} onChange={(e)=>setConfirm(e.target.value)} className="bg-transparent flex-1 py-3 outline-none text-sm" />
                  </div>
                </div>
                <button data-testid="reset-submit" type="submit" disabled={loading} className="gold-btn w-full !py-3 disabled:opacity-50">
                  {loading ? "..." : "Valider"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
